import { Product } from "@transfr-inc/dashboard-components/constants";
import { getProduct } from "@transfr-inc/dashboard-components/utils";

import {
  ProfessionalLearningProduct,
  TrekTrainProduct,
} from "@components/custom/dropdowns/product-dropdown-list";

export const getInstructorSortValue = (classroom) => {
  if (classroom.instructors && classroom.instructors.length >= 1) {
    if (classroom.instructors.length > 1) {
      return classroom.totalInstructors.toString();
    }
    return `${classroom.instructors[0].lastName.toLowerCase()}, ${classroom.instructors[0].firstName.toLowerCase()} `;
  }
};

export const resolveProduct = (productId) => {
  if (!productId) return undefined;
  if (productId === ProfessionalLearningProduct.id)
    return ProfessionalLearningProduct;
  if (productId === TrekTrainProduct.id) return TrekTrainProduct;
  return getProduct(productId) ?? getProduct(Number(productId));
};

export const resolveProductFilter = (productId) => {
  if (!productId) return { products: [], professionalLearning: false };
  if (productId === ProfessionalLearningProduct.id)
    return { products: [], professionalLearning: true };
  if (productId === "CE_TRK")
    return { products: [Product.CE, Product.TRK], professionalLearning: false };
  if (productId === "TRK_TS")
    return {
      productsPredicate: (classroomProducts) =>
        classroomProducts.includes(Product.TS) &&
        (classroomProducts.includes(Product.CE) ||
          classroomProducts.includes(Product.TRK)),
      professionalLearning: false,
    };
  return { products: [Number(productId)], professionalLearning: false };
};

export const filterClassrooms = (classrooms, filters) => {
  const data = [...classrooms];

  return data.filter((c) => {
    if (
      filters.classroomIds?.length > 0 &&
      !filters.classroomIds.includes(c.id)
    ) {
      return false;
    }
    if (
      filters.organization &&
      c.organizationCode !== filters.organization.code
    ) {
      return false;
    }
    if (filters.professionalLearning) {
      return c.isProfessionalLearning === true;
    }
    if (filters.products?.length > 0 || filters.productsPredicate) {
      if (c.isProfessionalLearning) {
        return false;
      }

      if (filters.productsPredicate) {
        return filters.productsPredicate(c.products);
      } else {
        return filters.products.some((p) => c.products.includes(p));
      }
    }
    return true;
  });
};

export const getArchiveresultMessage = (archived, blocked) => {
  const message = [];
  if (archived?.length > 0) {
    const classroomNoun = archived.length == 1 ? "classroom" : "classrooms";
    message.push(`${archived.length} ${classroomNoun} archived`);
  }
  if (blocked?.length > 0) {
    const classroomNoun = blocked.length == 1 ? "classroom" : "classrooms";
    message.push(
      `${blocked.length} ${archived.length > 0 ? "" : classroomNoun} skipped.`
    );
  }
  return message.join(", ");
};

export const getUnarchiveResultMessage = (count) => {
  const classroomNoun = count === 1 ? "classroom" : "classrooms";
  return `${count} ${classroomNoun} unarchived`;
};
